import { useTheme } from "@/hooks/useTheme";

export function Html({ children }: { children: React.ReactNode }) {
	const { theme } = useTheme();

	return (
		<html lang="pt-BR" className={theme === "dark" ? "dark" : ""}>
			{children}
		</html>
	);
}
